import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Layout from '@/components/layout'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' // Progress 进度条样式

// const _import = require('./_import_' + process.env.NODE_ENV);
const _import = require('./_import_production');
// console.log(process.env.NODE_ENV);

Vue.use(VueRouter)

const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
    return VueRouterReplace.call(this, to).catch(err => err)
}

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

const routes = [
    { path: '/', redirect: '/index' },
    {
        path: '/password',
        name: 'password',
        component: Layout,
        children: [{
            path: "",
            component: _import("/password"),
            meta: { title: '修改密码', fullPath: '/password', isHide: true }
        }]
    },
    // {
    //   path: '/review',
    //   name: 'review',
    //   component: Layout,
    //   children: [
    //     {
    //       path: "",
    //       component: _import("/review"),
    //       meta: { title: '审核列表', fullPath: '/review', isHide: true }
    //     }
    //   ]
    // },
    {
        path: '/login',
        name: 'login',
        component: _import('/login'),
        meta: {
            noAuth: true
        }
    },
    // {
    //   path: '/qywxAuth/:path?',
    //   name: 'qywxAuth',
    //   component: _import('/qywxAuth'),
    //   props: true,
    //   meta: {
    //     title: '微信企业认证',
    //     noAuth: true
    //   }
    // }
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    // if(to.meta.ColumnName){
    //   let head = document.getElementsByTagName('head');
    //   if(head[0].length-1) {
    //     head[0].removeChild([head[0].length-1])
    //   }
    //   let meta = document.createElement('meta');
    //   meta.content = to.meta.ColumnName;
    //   head[0].appendChild(meta)
    //  }
    // if (to.meta.isFrontColumn) {
    //   window.scrollTo(0, 0);
    // }
    NProgress.start()
    if (to.meta && to.meta.noAuth) {
        next()
    } else {
        if ((from.meta.noAuth || to.meta.noAuth) && from.path !== '/login') {
            next('/')
            NProgress.done()
            return
        }
        /* 判断是否有已登录 */
        if (localStorage.getItem("token") ? true : false) {
            /* 判断是否已读取身份信息 */
            if (store.getters.hasIdentityInfo) {
                next()
            } else {
                /* 获取身份信息 */
                store.dispatch("getIdentityInfo").then(res => {
                    let permissionMenus = res.Menus;
                    let permissionRouters = [];

                    /*先取出顶级菜单，Pid为0的就是顶级菜单*/
                    permissionMenus.forEach((m, i) => {
                        if (m.Pid == 0) {
                            let parentMenu = {
                                path: m.FullPath,
                                name: m.Url,
                                component: Layout,
                                meta: { id: m.MenuId, title: m.MenuName, fullPath: m.FullPath, icon: 'component', type: m.MenuType, }
                            }
                            permissionRouters.push(parentMenu)
                        }
                    })

                    function convertTree(routers) {
                        routers.forEach(r => {
                            permissionMenus.forEach((m, i) => {
                                if (m.Pid != 0 && m.Pid == r.meta.id) {
                                    if (!r.children) r.children = []
                                        // let isArticel = m.FullPath == '/articles/webarticle';
                                    let importPath = m.FullPath

                                    // m.Url = isArticel ? "webarticle" + m.Meta.ColumnId : m.Url;
                                    // m.FullPath = isArticel ? importPath + m.Meta.ColumnId : m.FullPath;
                                    let menu = {
                                        path: m.Url,
                                        name: m.Url,
                                        component: _import(importPath + "/"),
                                        meta: {
                                            id: m.MenuId,
                                            title: m.MenuName,
                                            fullPath: m.FullPath,
                                            // ColumnId: m.Meta != null ? m.Meta.ColumnId : null,
                                            // ColumnType: m.Meta != null ? m.Meta.ColumnType : null,
                                        }
                                    }
                                    r.children.push(menu)
                                }
                            })
                            if (r.children) {
                                convertTree(r.children)
                            }
                        })
                    }
                    convertTree(permissionRouters)

                    permissionRouters.unshift({
                        path: '/dashboard',
                        name: 'dashboard',
                        component: Layout,
                        meta: { title: '首页', fullPath: '/dashboard', isDashboard: true, affix: true, icon: 'dashboard' },
                        children: [{
                            path: "",
                            component: _import("/index"),
                            meta: { title: '首页', fullPath: '/dashboard', isHide: true }
                        }]
                    })

                    store.commit('SET_PERMISSION_ROUTERS', permissionRouters);
                    router.addRoutes(permissionRouters);
                    router.addRoutes([{ path: '*', redirect: '/dashboard' }]);
                    next({ path: to.path, replace: true, query: to.query });
                })
            }
        } else {
            next('/login')
            if (from.path == "/login") {
                NProgress.done()
            }
        }
    }
    // next({ path: to.path, replace: true });
})

router.afterEach((to, from) => {
    NProgress.done()
    if (to.meta && to.meta.title) {
        document.title = to.meta.title + ' | ' + store.state.sys.title
    } else {
        document.title = store.state.sys.title
    }
})

export default router